<template>
  <div class="member-service">
    <div class="aboutDlabel_content">
      軟體許可和服務協議

重要通知
深圳市雲聯軟件有限公司（以下簡稱“雲聯”）在此提醒所有用戶認真閱讀並充分理解本軟體許可和服務協議（以下簡稱“協議”）。用戶應仔細閱讀並充分理解本協議條款，特別是與雲聯責任的免除或限制、爭議解決及適用法律相關的條款。請仔細閱讀本協議並決定您是否願意接受此處列出的條款（未成年人應與其法定監護人一起閱讀本協議）。下載、安裝和使用本軟體或打開並登錄您的帳戶，即表示您接受本協議條款並受其法律約束。
雲聯保留修改本協議的權利。修改後的條款應在官網公告或隨軟體一起發佈，新條款自發布之日起生效。用戶可以下載並重新安裝軟體或在網站上流覽修改後的條款。如果您不接受本協議修改後的條款，請立即停止使用雲聯提供的軟體和服務。用戶繼續使用雲聯提供的軟體和服務，即表示用戶接受本協議修改後的條款。
 
一、總則
1.1. 本軟體和服務由雲聯提供，用於安裝（包括但不限於）智能移動設備，為使用智能設備的用戶提供設備配對、智能產品操作等服務。
1.2. 軟體和服務的所有權和運行權歸雲聯所有。

二、軟體許可範圍
2.1. 雲聯授予用戶個人、不可轉讓和非排他性的軟體使用許可，無權重新許可。
2.2. 用戶可出於非商業目的在單個移動終端設備上安裝、使用、顯示和運行該軟體。但是，用戶不得出於任何商業運營目的安裝、使用或運行本軟體。用戶不得複製、更改或修改軟體中存儲的任何數據，軟體執行過程中釋放到任何終端設備記憶體中的數據，或軟體執行過程中客戶端與伺服器交互過程中產生的任何數據。用戶不得通過其他軟體操作本軟體或以任何形式創建本軟體的任何衍生產品，包括但不限於插件、機器人，或通過未經授權的第三方工具/服務訪問本軟體及相關系統。如果您必須出於商業目的銷售、複製或分發本軟體，例如用於軟體預安裝和捆綁，您必須事先獲得雲聯的書面授權和許可。
2.3. 未經雲聯許可，用戶不得在未經雲聯明確許可的情況下將軟體安裝在其他終端設備上，包括但不限於機頂盒、遊戲機、電視機、DVD播放器等。
2.4. 用戶可以出於使用軟體和服務的目的製作軟體副本，僅作為備份使用。所有備份副本都應包含與原始軟體一起提供的版權資訊。
2.5. 除本協議明確授權外，雲聯不授予用戶其他權利。用戶如需行使其他權利，應事先征得雲聯的書面同意。

三、軟體獲取、安裝、升級
3.1. 用戶應按照雲聯指定的方法下載安裝軟體。請注意不要從非指定網站下載本軟體，以免移動設備感染惡意程式，破壞用戶數據，獲取用戶機密資訊。如果您從未經雲聯授權的第三方處獲得本軟體或與該軟體同名的安裝程式，雲聯無法保證軟體的正常功能，對您因使用而遭受的任何損失，雲聯不承擔任何這樣的責任。
3.2. 用戶必須選擇與要安裝的終端設備相匹配的軟體版本。否則，因在設備型號上使用不相容的軟體版本而導致的任何軟體問題、設備問題或損壞將由用戶承擔。
 
四、使用規範

4.1. 用戶可以按照本協議和相關法律的規定使用本軟體和服務。用戶不得有以下行為：
4.1.1. 刪除本軟體及其他副本中的任何版權資訊，或修改、刪除或規避本軟體設置的保護知識產權的技術措施；
4.1.2. 對軟體進行逆向工程，如反彙編、反編譯或其他試圖獲取軟體源代碼的嘗試；
4.1.3. 通過修改、偽造軟體運行過程中的指令和數據，增加、刪除或改變軟體的功能或運行效果，或以其他方式運行或向公眾傳播用於上述目的的軟體或方法，無論此類行為是否或是否出於商業目的；
4.1.4. 使用本軟體執行任何危害網路安全的行為，包括但不限於：使用未經授權的數據或訪問未經授權的伺服器/帳戶；未經授權訪問公共網路或其他人的操作系統，以及 刪除、修改或添加任何已保存的數據；試圖未經授權檢測、掃描或測試軟體系統或網路弱點，或進行其他破壞網路安全的行為；試圖干擾或破壞軟體系統或網站的正常運行，故意傳播惡意程式或病毒，或其他破壞或干擾正常網路資訊服務的行為；偽造TCP/IP數據包的名稱或部分名稱；
4.1.5. 用戶通過非雲聯開發、授權或認可的第三方相容軟體或系統登錄或使用本軟體和服務，或製作、發佈、傳播上述工具；
4.1.6 未經雲聯書面同意，用戶對本軟體或其中所含數據的行為包括但不限於：使用、出租、複製、修改、鏈接、複製、編譯、發佈、發佈或未經授權擅自創建本軟體的使用軟體開發相關的衍生產品、作品、服務、插件、機器人、相容性或互聯鏡像站點；
4.1.7. 使用本軟體發佈、傳輸、廣播或存儲違反當地法律法規的內容；
4.1.8. 使用本軟體發佈、傳輸、傳播或存儲任何侵犯他人合法權益的內容，如知識產權、商業秘密等；
4.1.9. 使用本軟體批量發佈、傳輸或傳播廣告資訊或垃圾郵件；
4.1.10. 以任何非法方式、為任何非法目的或以任何與本協議允許的使用方式不一致的方式使用雲聯提供的軟體和其他服務；
4.2. 資訊發佈規範
4.2.1. 您可以使用本軟體發佈最初由您創建或您有權發佈的內容，例如意見、數據、文本、資訊、用戶名、圖像、照片、個人數據、音頻/視頻檔和鏈接。您必須確保對您上傳的資訊擁有知識產權或已獲得合法授權，並且您對軟體和服務的使用不侵犯任何第三方的合法權益。
4.2.2. 用戶在使用本軟體時，應遵守當地法律法規。
4.2.3. 您不得使用本軟體執行以下操作，包括但不限於：
4.2.3.1. 製作、複製、發佈、傳播或存儲任何違反當地法律法規的內容；
4.2.3.2. 發佈、傳播、傳播或儲存任何侵犯他人名譽權、人格權、知識產權、商業秘密等合法權益的內容；
4.2.3.3. 編造虛構事實或隱瞞真相誤導、欺騙他人的；
4.2.3.4. 發佈、傳輸或傳播廣告資訊或垃圾郵件；
4.2.3.5. 從事任何其他違反當地法律法規的行為。
4.2.4. 未經雲聯許可，您不得在本軟體內進行任何商業活動，如廣告、商品銷售等。
4.3. 您理解並同意：
4.3.1. 雲聯將判斷用戶是否涉嫌違反上述使用規範，並根據判斷暫停或終止授予您的使用許可或採取其他本協議規定可能採取的限制措施結果;
4.3.2 雲聯將直接刪除用戶在使用許可軟體過程中發佈的涉嫌違法、侵犯他人合法權益或違反本協議的資訊；
4.3.3. 如果您違反上述使用規則給第三方造成損害，您需要以自己的名義承擔責任，您應保護雲聯免受由此產生的任何損失或費用；
4.3.4. 用戶應對因用戶原因而遭受或蒙受的任何及全部損失、第三方索賠、行政處罰和損害和/或費用，包括合理的律師費和調查取證費等，給予雲聯賠償，並使雲聯免受損害。違反相關法律或違反本協議。
 
五、服務風險及免責聲明
5.1. 除非法律法規另有規定，我們將盡最大努力確保所涉及的軟體及技術和資訊的安全、有效、準確和可靠；但由於目前的技術限制，用戶理解雲聯無法提供任何保證。
5.2. 用戶應對任何人身傷害或附帶或間接經濟損失承擔全部責任，包括但不限於利潤損失、數據丟失和業務中斷的賠償，或任何其他商業損失或賠償要求。與以下任何一種情況有關：
5.2.1. 使用或未能使用許可軟體；
5.2.2. 第三方未經授權使用本軟體或修改用戶數據；
5.2.3. 用戶在使用本軟體過程中發生的費用和損失；
5.2.4. 對軟體用戶的誤解；
5.2.5. 與本軟體相關的其他非雲聯原因造成的損失。
5.3. 對於用戶及其他用戶通過本軟體造成或可能造成的人身傷害或經濟損害或損失，本軟體應依法承擔當事人的過錯。

六、知識產權聲明
6.1. 雲聯是本軟體的知識產權所有人。與本軟體相關的所有知識產權，如版權、商標、專利、商業秘密等，以及與本軟體相關的所有資訊（包括但不限於文字、圖片、音頻、視頻、圖形、介面設計、版面設計等） 、數據或電子檔等）受您當前居住地區的法律法規和相應的國際條約保護。雲聯享有上述知識產權。
6.2. 未經雲聯事先書面同意，用戶不得出於任何商業或非商業目的獨立使用或轉讓上述任何知識產權，或允許任何第三方這樣做。雲聯保留對此類行為追究法律責任的權利。
 
七、適用法律和爭議解決
7.1. 本協議的效力和解釋適用中華人民共和國大陸地區法律。在沒有相關法律規定的情況下，可以參考國際商業慣例和/或商業慣例。
7.2. 用戶與雲聯均同意，因服務產生的任何爭議應由雙方協商解決。如協商不能解決，任何一方均可將爭議提交本協議簽訂地有管轄權的法院。
 
八、其他
8.1. 本軟體的具體服務可能存在單獨的協議及相關業務規則（以下統稱“單獨協議”），請在使用具體服務前閱讀並同意相關單獨協議。
8.2. 該協議將於 2021 年 12 月 03 日生效。
8.3. 本協議中所有條款的名稱僅供參考，本身沒有實際意義；它們不能用於解釋本協議的含義。
8.4. 如果本協議的任何條款因任何原因無效或不可執行，本協議的其餘條款仍然完全有效，並對本協議雙方具有約束力。
雲聯
    </div>
  </div>
</template>

<script>
export default {
  created() {
      
    document.querySelector('title').innerHTML = '軟體許可和服務協議'
    setTimeout(() => {
      document.body.scrollTop = 0;
    }, 0);
  },
};
</script>

<style lang="scss" scoped>
.member-service {
  padding: 0.4rem 0.4rem;
}
</style>